import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React, { useState } from "react";
import * as motion from "motion/react-client";
import { Video } from "./Monitoring/Video";
import { Targeted } from "./Monitoring/Targeted";
import { Box, Typography } from "@mui/material";
import { NoDisplayLive } from "Component/EmptyData/NoDisplayLive";
import { useDispatch, useSelector } from "react-redux";
import {
  playbackCamera,
  playbackSelected,
  playbackSelectedCamera,
  playbackSidebar,
} from "slice/playbackSlice";
import { Videos } from "./Monitoring/Videos";
import { capitalizeFirstLetter } from "Helper";
import Detail from "./Monitoring/Detail";
import { clearVideoResponse } from "slice/videoResponseSlice";
import { LoadingLive } from "Component/LoadingModal/LoadingLive";

export const PlaybackMonitoring = () => {
  let conTrueData;
  let conFalseData;

  const dispatch = useDispatch();
  const [srcVideo, setSrcVideo] = useState(null);
  const playback = useSelector((state) => state.playback.value);
  const camera = useSelector((state) => state.playback.selectedCamera);
  const valueCamera = useSelector((state) => state.playback.valueCamera);
  const { datavideoList, isLoadingvideoList } = useSelector(
    (state) => state.videoList.videoList
  );
  const { datavideoResponse } = useSelector(
    (state) => state.videoResponse.videoResponse
  );

  // console.log(playback, "playback");
  // console.log(valueCamera, "valueCamera");

  // console.log(datavideoResponse, "datavideoResponse");
  const { dataIpCamList } = useSelector((state) => state.ipCam.ipCamList);
  const filteredTrue = Array.isArray(datavideoResponse)
    ? datavideoResponse.filter(
        (item) => item.confidenceScore > 0.51 && item.isDpo === true
      )
    : [];

  const filteredFalse = Array.isArray(datavideoResponse)
    ? datavideoResponse.filter(
        (item) => item.confidenceScore > 0.51 && item.isDpo === false
      )
    : [];

  // console.log(playback, 'playback')
  if (datavideoResponse) {
    conFalseData = filteredFalse;
    conTrueData = filteredTrue;
  } else {
    conFalseData = [];
    conTrueData = [];
  }

  const handleBack = () => {
    dispatch(clearVideoResponse([]));
    dispatch(playbackSidebar(""));
    dispatch(playbackCamera(""));
    dispatch(playbackSelected(""));
    // dispatch(playbackSelectedCamera(""));
  };

  return (
    <div>
      <div className="">
        <div className="">
          <div className="h-7">
            {playback === "" ? (
              ""
            ) : (
              <div>
                {camera === null ? (
                  <div className="flex justify-start items-center mb-2  text-mo-text">
                    <div onClick={handleBack}>
                      <Box
                        component="span"
                        sx={{
                          color: "text.white",
                          cursor: "pointer",
                          "&:hover": { color: "cyan" },
                        }}
                      >
                        <ArrowBackIosIcon fontSize="small" />
                      </Box>{" "}
                    </div>
                    <motion.div
                      initial={{ opacity: 0, x: -50 }} // Mulai dari kiri (-50px)
                      animate={{ opacity: 1, x: 0 }} // Bergerak ke posisi normal
                      transition={{
                        duration: 0.6, // Lebih cepat (0.6 detik)
                        ease: [0.33, 1, 0.68, 1], // Bezier untuk transisi smooth tapi cepat
                      }}
                      className="flex"
                    >
                      <Typography variant="body1" component="h2">
                        <Box
                          className="font-bold"
                          component="span"
                          sx={{
                            color: "text.white",
                            // cursor: "pointer",
                            // "&:hover": { color: "cyan" },
                          }}
                        >
                          {datavideoList?.length} Kamera
                        </Box>{" "}
                        tersedia di{" "}
                        <Box
                          component="span"
                          className="font-bold"
                          sx={{
                            color: "text.white",
                            // cursor: "pointer",
                            // "&:hover": { color: "cyan" },
                          }}
                        >
                          {capitalizeFirstLetter(playback?.jurisdiction_name)}
                        </Box>
                      </Typography>
                    </motion.div>
                  </div>
                ) : (
                  <div className="flex justify-start items-center mb-2  text-mo-text">
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        dispatch(playbackSelectedCamera(null));
                        dispatch(playbackCamera(""));
                        dispatch(playbackSelected(""));
                        dispatch(clearVideoResponse([]));
                      }}
                    >
                      <ArrowBackIosIcon fontSize="small" />
                    </div>
                    <div className="flex">
                      <Box
                        component="span"
                        sx={{
                          color: "text.white",
                        }}
                      >
                        {capitalizeFirstLetter(playback?.jurisdiction_name)}
                      </Box>
                      <div className="mx-1"> / </div>
                      <motion.div
                        key={camera?.device_name}
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                          duration: 0.6,
                          ease: [0.33, 1, 0.68, 1],
                        }}
                        className="flex"
                      >
                        <Box
                          component="span"
                          className="font-bold"
                          sx={{
                            color: "text.white",
                          }}
                        >
                          {valueCamera?.nama_video}
                        </Box>
                      </motion.div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div>
            {!playback ? (
              <div className="w-full flex flex-row ">
                <div className="w-full ">
                  {valueCamera === "" ? (
                    <Videos srcVideo={srcVideo} setSrcVideo={setSrcVideo} />
                  ) : (
                    <div className="h-full flex flex-col md:flex-row">
                      <div className="w-full md:basis-9/12">
                        <div>
                          <div>
                            <Video
                              srcVideo={srcVideo}
                              setSrcVideo={setSrcVideo}
                            />
                          </div>
                          <div>
                            <Detail
                              trueData={conTrueData}
                              falseData={conFalseData}
                              valueCamera={valueCamera}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-full md:basis-3/12 mt-5 md:mt-0 md:ml-5 text-mo-text">
                        <Targeted
                          trueData={conTrueData}
                          falseData={conFalseData}
                          camera={valueCamera}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <NoDisplayLive />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
